import FormAccordionBase from '@/components/forms/new/FormAccordionBase';
import FormBase from '@/components/forms/new/FormBase';
import Drawer from 'components/presentational/Drawer';
import UserAccordion from '../accordionComponents/UserAccordion';
import { useEffect, useState, useRef } from 'react';
import { LoadingIndicator, Button } from '@/components/v4';
import { useSelector } from 'react-redux';
import useUpdateAllPlatformUsers from '../../queries/useUpdateAllPlatformUsers';
import useUpdateTCAPUsers from '../../queries/useUpdateTCAPUsers';
import {
    Avatar,
    Box,
    Heading,
    HStack,
    IconButton,
    Tooltip,
    useDisclosure,
} from '@chakra-ui/react';
import { headingStyling } from '@/components/forms/new/formStyles';
import Services from '../../services/Services';
import { ServicesProvider } from '../../services/ServicesContext';
import { AiOutlineUserAdd } from 'react-icons/ai';
import { AiOutlineArrowLeft } from 'react-icons/ai';
import useAssignTCAPUser from '../../queries/useAssignTCAPUser';
import useUnassignTCAPUser from '../../queries/useUnassignTCAPUser';
import UserPlatformDropdown from '../formFields/UserPlatformDropdown';
import UserPlatformUserDropdown from '../formFields/UserPlatformUserDropdown';
import UnlinkUserModal from '../modal/UnlinkUserModal';
import { FaUnlink } from 'react-icons/fa';
import { PlatformEnums } from '@/utils/platforms';
import EightByEightUserEditContent from './EightByEightUserEditContent';
import RingGroupEditContent from './RingGroupEditContent';
import GenericPlatformUserEditContent from './GenericPlatformUserEditContent';
import { getGenericSimpleServiceProfilePlatformById } from 'services/platformRegistry';

import useGetCurrentCompany from '@/queries/company/useGetCurrentCompany';
import useGetCurrentCompanyVendorService from '@/queries/company/useGetCurrentCompanyVendorService';
const UserEditDrawer = ({
    isOpen,
    onClose,
    expandedPlatformUsers,
    selectedPlatform,
    platformRefetch,
    setExpandedPlatformUsers,
    refreshTable,
    isFetchingData,
    tcapUserId,
    usersList,
    setExpandedPlatformUsersToEmpty,
    initialPrimaryUser,
}) => {
    const { darkMode } = useSelector((state) => state.settings);

    const { currentCompanyPlatforms, currentCompany } = useSelector(
        (state) => state.navigationLists,
    );
    const { data: companyData } = useGetCurrentCompany();
    const { data: vendorService } = useGetCurrentCompanyVendorService();

    const filteredPlatforms = currentCompanyPlatforms?.filter(
        (platform, index, self) =>
            index === self.findIndex((p) => p.id === platform.id) &&
            (platform.id === PlatformEnums.ZOOM ||
                platform.id === PlatformEnums.TEAMS),
    );

    const {
        isOpen: isModalOpen,
        onOpen: onModalOpen,
        onClose: onModalClose,
    } = useDisclosure();
    const finalRef = useRef(null);
    const [submitData, setSubmitData] = useState([]);
    const [isAssigning, setIsAssigning] = useState(false);
    const setAssigningToFalse = () => setIsAssigning(false);
    const [assigningPlatformUserId, setAssigningPlatformUserId] = useState();
    const [unassigningPlatformUserId, setUnassigningPlatformUserId] =
        useState();
    const [platformDropdown, setPlatformDropdown] = useState();
    const [platformUsers, setPlatformUsers] = useState(usersList);
    const [newPrimaryUser, setNewPrimaryUser] = useState();

    const accountScope = useSelector((state) => state.login.currentScope);

    const updateEditDrawer = async () => {
        let res;
        do {
            res = await platformRefetch();
        } while (!res.data || res.error);
        const prioritisedRes = res.data.sort((a, b) => a.priority - b.priority);
        setExpandedPlatformUsers(prioritisedRes);
        refreshTable();
    };

    const { mutate: updateAllPlatformUsers } = useUpdateAllPlatformUsers({
        data: submitData,
        accountScope: accountScope,
        oldData: expandedPlatformUsers,
        currentCompany: currentCompany,
        refetchPlatformUsers: updateEditDrawer,
    });

    const { mutate: assignPlatformUser } = useAssignTCAPUser({
        tcapUserId,
        platformUserId: assigningPlatformUserId,
        accountScope,
        refetchPlatformUsers: updateEditDrawer,
        setIsAssigning,
    });

    const { mutate: unassignPlatformUser } = useUnassignTCAPUser({
        tcapUserId,
        platformUserId: unassigningPlatformUserId,
        accountScope,
        refetchPlatformUsers: updateEditDrawer,
    });

    //Update TCAP User exists to update priority and primary user. The actual platform saving is handled by the useUpdateAllPlatformUsers hook.
    const { mutate: updateTCAPUser } = useUpdateTCAPUsers({
        tcapUserId: tcapUserId,
        formData: newPrimaryUser,
        originalData: initialPrimaryUser,
        accountScope: accountScope,
        refetchPlatformUsers: updateEditDrawer,
    });

    const selectedPlatformIndex = Array.isArray(expandedPlatformUsers)
        ? expandedPlatformUsers.findIndex(
              (platform) =>
                  platform?.platformID === selectedPlatform?.platformID,
          )
        : 0;

    useEffect(() => {
        setSubmitData(expandedPlatformUsers);
        setNewPrimaryUser(initialPrimaryUser);
    }, [expandedPlatformUsers, initialPrimaryUser, isOpen]);

    useEffect(() => {
        setPlatformUsers(
            usersList.filter(
                (user) => user?.primaryUser?.platformID === platformDropdown,
            ),
        );
    }, [platformDropdown, usersList]);

    const finalFormSubmit = async (value) => {
        const finalSubmit = submitData.map((submittingUser, index) => {
            return {
                ...submittingUser,
                platformAttribute1: value.formValues[index].platformAttribute1,
                platformAttribute2: value.formValues[index].platformAttribute2,
                platformAttribute3: value.formValues[index].platformAttribute3,
            };
        });

        setSubmitData(finalSubmit);

        try {
            await Promise.all([
                new Promise((resolve, reject) => {
                    updateTCAPUser(undefined, {
                        onSuccess: resolve,
                        onError: reject,
                    });
                }),
                new Promise((resolve, reject) => {
                    updateAllPlatformUsers(undefined, {
                        onSuccess: resolve,
                        onError: reject,
                    });
                }),
            ]);
            onClose();
        } catch (error) {
            // Modal stays open on error
        }
    };

    const assignPlatform = () => {
        assignPlatformUser();
    };
    const [initialIndex, setInitialIndex] = useState();

    useEffect(() => {
        setInitialIndex(selectedPlatformIndex);
    }, [selectedPlatform, selectedPlatformIndex]);

    const [openIndexes, setOpenIndexes] = useState([initialIndex]);

    useEffect(() => {
        setOpenIndexes([selectedPlatformIndex]);
    }, [selectedPlatformIndex]);

    const movePlatform = (index, direction) => {
        setSubmitData((prevSubmitData) => {
            const updatedSubmitData = [...prevSubmitData];
            const targetIndex = index + direction;

            if (targetIndex >= 0 && targetIndex < updatedSubmitData.length) {
                [updatedSubmitData[index], updatedSubmitData[targetIndex]] = [
                    updatedSubmitData[targetIndex],
                    updatedSubmitData[index],
                ];
                setNewPrimaryUser(updatedSubmitData[0]);
                setOpenIndexes((prevOpenIndexes) => {
                    return prevOpenIndexes.map((openIndex) => {
                        if (openIndex === index) return targetIndex;
                        if (openIndex === targetIndex) return index;
                        return openIndex;
                    });
                });
            }
            return updatedSubmitData;
        });
    };

    const accordionController = {
        openIndexes,
        setOpenIndexes,
    };

    // TODO: To be reused later
    const unlinkButton = (unassigningPlatformId) => {
        return (
            submitData?.length > 1 && (
                <Tooltip
                    label="Unlink Platform User"
                    aria-label="Unlink Platform Tooltip">
                    <IconButton
                        aria-label="Unlink Platform"
                        variant="ghost"
                        size="sm"
                        icon={<FaUnlink />}
                        zIndex={2000}
                        colorScheme="black"
                        onClick={(e) => {
                            e.stopPropagation();
                            setUnassigningPlatformUserId(unassigningPlatformId);
                            onModalOpen();
                        }}
                        data-walkthroughid="userEditDrawerUnlinkPlatform"
                        sx={{
                            pointerEvents: 'auto',
                        }}
                    />
                </Tooltip>
            )
        );
    };

    const accordionFields = (errors, touched, values) => {
        return Array.isArray(submitData)
            ? submitData?.map((platformUser, index) => (
                  <UserAccordion
                      key={platformUser?.platformID}
                      platformUser={platformUser}
                      errors={errors}
                      touched={touched}
                      value={values}
                      submitData={submitData}
                      setSubmitData={setSubmitData}
                      onMoveUp={() => movePlatform(index, -1)}
                      onMoveDown={() => movePlatform(index, 1)}
                      platformIndex={index}
                      platformNumbersLength={submitData.length}
                      unlinkButton={unlinkButton(platformUser?.id)}
                      primaryUser={newPrimaryUser || initialPrimaryUser}
                  />
              ))
            : [];
    };

    const assigningFields = (errors, touched) => [
        <UserPlatformDropdown
            key="platformDropdown"
            setPlatformDropdown={setPlatformDropdown}
            setAssigningPlatformUserId={setAssigningPlatformUserId}
            platformDropdown={platformDropdown}
            errors={errors}
            touched={touched}
            darkMode={darkMode}
            availablePlatforms={filteredPlatforms}
        />,
        platformDropdown && (
            <UserPlatformUserDropdown
                key="platformUserDropdown"
                assigningPlatformUserId={assigningPlatformUserId}
                setAssigningPlatformUserId={setAssigningPlatformUserId}
                errors={errors}
                touched={touched}
                darkMode={darkMode}
                platformUsers={platformUsers}
                platformNumbersLength={submitData.length}
            />
        ),
    ];

    const header = (
        <HStack>
            <Box sx={{ paddingBottom: '15px' }}>
                <Avatar
                    size="sm"
                    bg="#007BFF"
                    color="white"
                    name={initialPrimaryUser?.displayName}
                    showBorder
                    borderWidth="1px"
                />
            </Box>
            <Heading sx={headingStyling}>
                {initialPrimaryUser?.displayName}
            </Heading>
        </HStack>
    );

    const extraCards = [
        <Box key="servicesHeader" heading="Add On Services">
            <ServicesProvider key="userServicesProvider">
                <Services userID={initialPrimaryUser?.id} />
            </ServicesProvider>
        </Box>,
    ];

    // TODO: Commenting out Linking for US#47
    const extraButton = (
        <Box
            key="changeForm"
            sx={{
                justifyContent: 'flex-start',
                alignItems: 'center',
                display: 'flex',
            }}>
            <Tooltip
                label={
                    isAssigning ? 'Return to User Edit' : 'Link a Platform User'
                }
                aria-label="Assign Platform Tooltip">
                <IconButton
                    aria-label="Assign Platform"
                    size="lg"
                    icon={
                        isAssigning ? (
                            <AiOutlineArrowLeft />
                        ) : (
                            <AiOutlineUserAdd />
                        )
                    }
                    onClick={() => setIsAssigning(!isAssigning)}
                    borderRadius={50}
                    variant="solid"
                />
            </Tooltip>
        </Box>
    );

    const isEightByEight =
        selectedPlatform?.platformID === PlatformEnums.EIGHTBYEIGHT;
    const isRingGroup =
        selectedPlatform?.primaryUser?.userType === 'RingGroup' ||
        selectedPlatform?.userType === 'RingGroup';
    const genericSimplePlatform = getGenericSimpleServiceProfilePlatformById(
        selectedPlatform?.platformID,
    );

    return (
        <>
            <Drawer
                isOpen={isOpen}
                onCloseAction={() => {
                    setExpandedPlatformUsersToEmpty();
                    setAssigningToFalse();
                    setAssigningPlatformUserId(undefined);
                    setUnassigningPlatformUserId(undefined);
                    setPlatformDropdown(undefined);
                    setOpenIndexes([]);
                }}
                onClose={onClose}>
                {isFetchingData || submitData === undefined ? (
                    <LoadingIndicator />
                ) : isEightByEight && isRingGroup ? (
                    <RingGroupEditContent
                        selectedPlatform={selectedPlatform}
                        expandedPlatformUsers={expandedPlatformUsers}
                        onClose={onClose}
                        onSave={() => onClose()}
                        darkMode={darkMode}
                    />
                ) : isEightByEight ? (
                    <EightByEightUserEditContent
                        selectedPlatform={selectedPlatform}
                        onClose={onClose}
                        onSave={() => onClose()}
                        darkMode={darkMode}
                    />
                ) : genericSimplePlatform ? (
                    <GenericPlatformUserEditContent
                        displayName={genericSimplePlatform.displayName}
                        selectedPlatform={selectedPlatform}
                        onClose={onClose}
                        onSave={() => onClose()}
                        darkMode={darkMode}
                    />
                ) : isAssigning ? (
                    <FormBase
                        header={header}
                        noBackBtn
                        initialValues={submitData}
                        finalFormSubmit={assignPlatform}
                        extraButton={extraButton}
                        ufBackBtn="userEditDrawerBackBtn"
                        ufSaveBtn="userEditDrawerSaveBtn">
                        {({ errors, touched, values }) =>
                            assigningFields(errors, touched, values)
                        }
                    </FormBase>
                ) : (
                    <FormAccordionBase
                        header={header}
                        noBackBtn
                        initialValues={submitData}
                        finalFormSubmit={finalFormSubmit}
                        controller={accordionController}
                        defaultIndex={initialIndex}
                        sideDrawer
                        extraCards={
                            vendorService &&
                            vendorService?.serviceType === 'VendorDefined'
                                ? extraCards
                                : undefined
                        }
                        extraButton={
                            <Button
                                variant="outline"
                                sx={{
                                    w: '142px',
                                    mr: 'calc(100% - 150px)',
                                }}
                                onClick={onClose}>
                                Cancel
                            </Button>
                        }
                        ufBackBtn="userEditDrawerBackBtn"
                        ufSaveBtn="userEditDrawerSaveBtn">
                        {({ errors, touched, values }) =>
                            accordionFields(errors, touched, values)
                        }
                    </FormAccordionBase>
                )}
            </Drawer>
            <UnlinkUserModal
                isOpen={isModalOpen}
                finalRef={finalRef}
                onClose={onModalClose}
                deleteOnClick={() => {
                    unassignPlatformUser();
                    onModalClose();
                }}
            />
        </>
    );
};

export default UserEditDrawer;
